import { MuscleToVector } from "@project-rouge/rg-three";
import { Vector3 } from "three";
var muscleV = new Vector3();
var muscleDir = new Vector3();
function getRealMusclePoint(muscle, pointIndex, out = new Vector3()) {
	if (muscle.lockEnds[pointIndex]) return out.fromArray(muscle.points[pointIndex]);
	MuscleToVector(muscle, muscleV);
	const dir = muscleDir.copy(muscleV).normalize();
	const diff = (muscleV.length() - muscle.realLength) * (pointIndex ? -1 : 1);
	return out.fromArray(muscle.points[pointIndex]).addScaledVector(dir, diff);
}
export { getRealMusclePoint };

//# sourceMappingURL=index5.js.map